module.exports = __webpack_public_path__ + "img/signature.de651c44.svg";